import { trackCustomEvent } from './helper.es.js';

const trackSearchEvent = (keyword) => {
  var _a;
  window.track("siteSearch", {
    params: "{}",
    keywords: keyword
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "view_search_results",
    content_keyword: keyword
  });
};
const trackSearchOrderEvent = ({
  eventName,
  category,
  keyword
}) => {
  return trackCustomEvent(eventName, {
    label: keyword,
    category
  });
};

export { trackSearchEvent, trackSearchOrderEvent };
